import { useState } from "react";
import "./Subscription.scss";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useNavigate } from "react-router-dom";

const Subscription = () => {
  const navigate = useNavigate();
  const [billingCycle, setBillingCycle] = useState("month");

  const { documents: subscriptionDoc } = useCollection("products", [
    "productType",
    "==",
    "subscription",
  ]);
  const { document: dbCurrencyDocuments } = useDocument("settings", "currency");

  return (
    <div className="subscription-page-parent-div">
      <div className="subscription-toggle-wrapper">
        <div className="subscription-toggle">
          <input
            type="radio"
            id="monthly"
            name="billing"
            checked={billingCycle === "month"}
            onChange={() => setBillingCycle("month")}
          />
          <label htmlFor="monthly">Monthly</label>

          <input
            type="radio"
            id="annually"
            name="billing"
            checked={billingCycle === "year"}
            onChange={() => setBillingCycle("year")}
          />
          <label htmlFor="annually">Annual</label>

          <input
            type="radio"
            id="weekly"
            name="billing"
            checked={billingCycle === "week"}
            onChange={() => setBillingCycle("week")}
          />
          <label htmlFor="weekly">Weekly</label>

          <div className="subscription-toggle-slider" />
        </div>
      </div>

      <div className="subscription-cards-container">
        {subscriptionDoc
          ?.filter((plan) => plan.subscriptionDurationType === billingCycle)
          .map((plan, index) => {
            const cleanFeatures = plan?.features
              ?.replace(/<[^>]+>/g, "")
              ?.split(/[•\-\n\r]+/)
              ?.filter((f) => f.trim() !== "");

            return (
              <div
                className={`subscription-card ${
                  index % 2 !== 0 ? "highlighted" : ""
                }`}
                key={plan.id}
                onClick={() => navigate(`/product-details-two/${plan.id}`)}
                style={{ cursor: "pointer" }}
              >
                <div className="left-subscription-taken-badge">Purchased</div>

                {plan.popularProducts === true ? (
                  <div className="subscription-discount-badge">Popular</div>
                ) : plan.discount !== "" ? (
                  <div className="subscription-discount-badge">
                    Save {plan.discount}
                  </div>
                ) : null}

                <h3 className="subscription-plan-title">{plan.name}</h3>

                <p className="subscription-plan-price">
                  <span>
                    {plan.discount !== "" && (
                      <del style={{ color: "red", fontSize: "18px" }}>
                        {dbCurrencyDocuments?.symbol}
                        {plan.price}&nbsp;
                      </del>
                    )}
                    {dbCurrencyDocuments?.symbol}
                    {/* {plan.price -
                      Math.ceil(
                        (plan.price * plan.discount.split("%")[0]) / 100
                      )} */}
                  </span>
                  /{plan.subscriptionDuration} {plan.subscriptionDurationType} (
                  {dbCurrencyDocuments?.code})
                </p>

                <p className="subscription-plan-description">
                  {plan.short_description}
                </p>

                <ul className="subscription-features">
                  {cleanFeatures?.slice(0, 7).map((feature, i) => (
                    <li key={i}>{feature.trim()}</li>
                  ))}
                  {cleanFeatures?.length > 7 && (
                    <li className="ellipsis">...</li>
                  )}
                </ul>

                <button className="btn_fill">
                  {plan.subscriptionFreeTrail && plan.subscriptionFreeTrail > 0
                    ? `Start ${plan.subscriptionFreeTrail}-days Free Trial`
                    : "Buy Now"}
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Subscription;
